import { useLanguage } from "../../lib/hooks/languageHooks"
import { useProxyPath } from "../../redux/hook/settingsHooks"
import theme from "../../theme"
import { tabletBreakpoint } from "../../lib/helper/viewportHelper"
import { Box, useMediaQuery } from "@material-ui/core"
import { Link as RouterLink } from "react-router-dom"
import React from "react"
import { Skeleton } from "@material-ui/lab"

function Thumbnail({
    href, src, content: contents, alt, loading, width, style, srcWidth, thumbNailId
}) {
    const language = useLanguage()
    const proxyPath = useProxyPath()
    const languageSpecificLink = `${proxyPath}/${language}${href?.startsWith("/") ? "" : "/"}${href}`
    const isSmall = useMediaQuery(theme.breakpoints.down(tabletBreakpoint))

    let image = contents?.find(content => content.language === language)?.image
    image = image ?? src

    const widthQuery = srcWidth !== undefined ? `?width=${srcWidth}&language=${language}` : ""

    const styleWithWidth = {
        width: width ?? (isSmall ? "auto" : "31%"),
        ...style
    }

    const LinkElement = (href && href !== "") ? RouterLink : Box

    return (
        (!loading)
            ? (
                <Box
                    id={thumbNailId}
                    style={{ ...styleWithWidth }}
                >
                    <LinkElement to={languageSpecificLink}>
                        <img
                            style={{ width: "100%" }}
                            src={`${process.env.REACT_APP_URL}${image}${widthQuery}`}
                            alt={alt}
                        />
                    </LinkElement>
                </Box>
            )
            : <Skeleton variant="rect" animation="wave" style={styleWithWidth} height="400px" />
    )
}

export default Thumbnail
